module.exports = __webpack_public_path__ + "img/gabriel_fandini.d0e71d02.png";